"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreventBrowserScroll = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Css_1 = require("../../Css");
/** Intended to wrap the whole application to prevent the browser's native scrolling behavior while also taking the full height of the viewport */
function PreventBrowserScroll({ children }) {
    return (
    // Take over the full viewport and hide any overflown content.
    // Using `-webkit-fill-available`, otherwise `height: 100vh` includes the app bars in mobile Safari. See https://allthingssmitty.com/2020/05/11/css-fix-for-100vh-in-mobile-webkit/
    // Setting the multiple "(min|max-)height" properties is necessary, as Truss will turn this into an object and there can only be one `height` property.
    (0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.overflowHidden.vh100.mh("-webkit-fill-available").maxh("-webkit-fill-available").$, children: (0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.h100.df.fdc.mh0.overflowAuto.$, children: children }) }));
}
exports.PreventBrowserScroll = PreventBrowserScroll;
